import { environment } from '@env/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class PeriodicService {
    constructor(http) {
        this.http = http;
    }
    getPeriodics(param = '') {
        return this.http.get(`${environment.base_url}/periodics?param=${param}`);
    }
    getPeriodicsByProject(projectId) {
        return this.http.get(`${environment.base_url}/periodics/projects/${projectId}`);
    }
    attachToProject(projectId, selectedPeriodicsIds) {
        return this.http.post(`${environment.base_url}/periodics/projects`, {
            project_id: projectId,
            periodics_ids: selectedPeriodicsIds
        });
    }
}
PeriodicService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PeriodicService_Factory() { return new PeriodicService(i0.ɵɵinject(i1.HttpClient)); }, token: PeriodicService, providedIn: "root" });
